import { ComparatorStep } from '@kizi/comparator-core';

const checkout: ComparatorStep = {
  path: 'checkout',
  name: 'checkout',
  fields: [],
};

export default checkout;
